import type { Nullable } from "@/types/utils";

export enum ClientFitCandidateArtifactStatus {
  Available = "available",
  Generated = "generated",
  Missing = "missing",
  NotReady = "not_ready",
  Pending = "pending",
  Rejected = "rejected",
  Error = "error",
}

export enum ClientFitCandidateArtifactKey {
  ClientFitPdf = "clientFitPdf",
  SuperscreenerPdf = "superscreenerPdf",
  Resume = "resume",
}

export interface ClientFitCandidateArtifact {
  downloadUrl: Nullable<string>;
  expiresAt: Nullable<string>;
  fileName: Nullable<string>;
  fileSize: Nullable<number>;
  generatedAt: Nullable<string>;
  message: Nullable<string>;
  status: ClientFitCandidateArtifactStatus;
  viewUrl: Nullable<string>;
}

export interface ClientFitCandidateArtifactSet {
  [ClientFitCandidateArtifactKey.ClientFitPdf]: ClientFitCandidateArtifact;
  [ClientFitCandidateArtifactKey.SuperscreenerPdf]: ClientFitCandidateArtifact;
  [ClientFitCandidateArtifactKey.Resume]: ClientFitCandidateArtifact;
}

export interface ClientFitCandidateArtifactExportResult {
  artifacts: ClientFitCandidateArtifactSet;
  candidateEmail: Nullable<string>;
  candidateName: Nullable<string>;
  jobTitle: string;
  location: string;
  profileVersionId: Nullable<string>;
  sessionId: string;
}

export interface ClientFitCandidateArtifactExportRequest {
  generateMissingClientFitPdf?: boolean;
  sessionIds: string[];
}

export interface ClientFitCandidateArtifactExportResponse {
  results: ClientFitCandidateArtifactExportResult[];
}
